<!-- 提现管理 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container withdraw-manage">
      <el-form size="mini" :inline="true" :model="listQuery" >
        <el-row>
          <!-- 申请时间 -->
          <el-form-item :label="$t('miMemberApply.createTime') + ':'" >
            <el-date-picker
                v-model="listQuery.startCreateTime"
                type="date"
                style="width: 130px;"
                value-format="yyyy-MM-dd"
                placeholder=""
            />&nbsp;&nbsp; - &nbsp;&nbsp;
            <el-date-picker
                v-model="listQuery.endCreateTime"
                type="date"
                style="width: 130px;"
                value-format="yyyy-MM-dd"
                placeholder=""
            />
          </el-form-item>
          <!-- 申请状态 -->
          <el-form-item :label="$t('fiBankbookTemp.status') + ':'">
            <el-select v-model="listQuery.status" placeholder="" clearable style="width: 120px">
              <el-option value="" />
              <el-option v-for="item in statusList" :key="item.code" :label="$lt(initDict.status, item.code)" :value="item.code" />
            </el-select>
          </el-form-item>
          <!-- 审核时间 -->
          <el-form-item :label="$t('pmProductSppm.checkDate') + ':'" >
            <el-date-picker
                v-model="listQuery.startCheckTime"
                type="date"
                style="width: 130px;"
                value-format="yyyy-MM-dd"
                placeholder=""
            />&nbsp;&nbsp; - &nbsp;&nbsp;
            <el-date-picker
                v-model="listQuery.endCheckTime"
                type="date"
                style="width: 130px;"
                value-format="yyyy-MM-dd"
                placeholder=""
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
          <el-button :loading="btnLoading" size="small" type="success" icon="el-icon-plus" @click="addBtn">{{ $t('busi.apply.account') }}</el-button>
        </el-row>
      </el-form >
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="80" align="center">
          <template v-slot="{row}">
            <el-button :loading="btnLoading" circle size="mini" icon="el-icon-search" :title="$t('button.view')" @click="viewTableBtn(row)" />
            <el-button v-if="row.status === 0 && this.userCode === row.createrCode" :loading="btnLoading" type="danger" circle size="mini" icon="el-icon-delete" :title="$t('poorder.cancelorder')" @click="cancelTableBtn(row)" />
          </template>
        </el-table-column>
        <!-- 申请单号 -->
        <el-table-column :label="$t('miMemberApalyCheck.askForNo')" prop="applNo" align="center"/>
        <!-- 用户编号 -->
        <el-table-column :label="$t('fiPayAdvice.userCode')" prop="userCode" align="center"/>
        <!-- 申请金额 -->
        <el-table-column :label="$t('FiAcAppl.amount')" prop="amount" align="center"/>
        <!-- 综合管理税费 -->
        <el-table-column :label="$t('fi.tax.multi')" prop="fees" align="center"/>
        <!-- 实发金额 -->
        <el-table-column :label="$t('fiBonusAppl.sendAmt')" prop="sendAmt" align="center"/>
        <!-- 发放币种 -->
        <el-table-column :label="$t('FiAcAppl.localCurrency')" prop="localCurrency" align="center"/>
        <!-- 发放金额 -->
        <el-table-column :label="$t('FiAcAppl.localMoney')" prop="localMoney" align="center"/>
        <!-- 申请时间 -->
        <el-table-column :label="$t('miMemberApply.createTime')" prop="createTime" align="center"/>
        <!-- 申请状态 -->
        <el-table-column :label="$t('csServiceCenter.status')" align="center">
         <template v-slot="{ row }">
           {{ $lt(initDict.status, row.status) }}
         </template>
        </el-table-column>
        <!-- 审核时间 -->
        <el-table-column :label="$t('pmProductSppm.checkDate')" prop="checkTime" align="center"/>
        <!-- 失败原因 -->
        <el-table-column :label="$t('fiBonusAppl.falseReason')" prop="falseReason" align="center"/>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getFiAcAppls, fiAcApplCancel } from '@/api/ay-account-manager'
import { mapGetters } from "vuex"
import Pagination from "@/components/Pagination"
export default {
  name: 'WithdrawManage',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      list: [],
      tableLoading: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      initDict: {
        status: 'fi_ac_appl_status_cn'
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode'
    ]),
    statusList() {
      return this.$ll(this.initDict.status)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      getFiAcAppls({ ...this.listQuery }).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        // this.getBalance()
        this.tableLoading = false
        this.btnLoading = false
      }).catch(err => {
        console.warn(err)
        this.tableLoading = false
        this.btnLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    addBtn() {
      this.$router.push({name: 'AddApply'})
    },
    viewTableBtn(row) {
      this.$router.push({name: 'ViewApply', params:{ id: row.id } })
    },
    cancelTableBtn(row) {
      this.btnLoading = true
      this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
        confirmButtonText: this.$t('yesno.yes'),
        cancelButtonText: this.$t('yesno.no'),
        type: 'warning'
      }).then(() => {
        fiAcApplCancel({ 'id': row.id}).then(() => {
          // 操作成功
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
          this.getList()
        }).catch(() => {
          // 操作失败
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
          this.btnLoading = false
        })
      }).catch(() => {
        this.btnLoading = false
        this.$message.info('po.status.3')
      })
    }
  }
}
</script>

<style scoped>

</style>